interface MarketingSeoOptions {
  title: string
  description: string
  path: string
}

export function useMarketingSeo(options: MarketingSeoOptions): void {
  const runtimeConfig = useRuntimeConfig()
  const siteUrl = String(runtimeConfig.public.SITE_URL).replace(/\/$/, '')
  const canonicalUrl = `${siteUrl}${options.path}`

  useSeoMeta({
    title: options.title,
    description: options.description,
    ogTitle: options.title,
    ogDescription: options.description,
    ogType: 'website',
    ogUrl: canonicalUrl,
    ogImage: `${siteUrl}/trident.svg`,
    ogLocale: 'fr_FR',
    twitterCard: 'summary',
    twitterTitle: options.title,
    twitterDescription: options.description,
    twitterImage: `${siteUrl}/trident.svg`,
  })

  useHead({
    link: [
      { rel: 'canonical', href: canonicalUrl },
    ],
    script: [
      {
        type: 'application/ld+json',
        innerHTML: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'SoftwareApplication',
          name: 'AppTrident',
          applicationCategory: 'FinanceApplication',
          operatingSystem: 'Web',
          description: options.description,
          url: canonicalUrl,
          inLanguage: 'fr-FR',
          offers: {
            '@type': 'Offer',
            price: '397',
            priceCurrency: 'EUR',
            category: 'annual subscription',
            url: `${siteUrl}/#tarif`,
          },
        }),
      },
    ],
  })
}
